import { useEffect, useState } from 'react';

/**
 * Flips to `true` one frame after mount so a freshly portalled surface can
 * animate in from its closed state. Reduced-motion users get the same two
 * renders; the CSS in theme.css collapses the transition duration for them.
 */
export function useEnterTransition(): boolean {
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    if (typeof requestAnimationFrame !== 'function') {
      setEntered(true);
      return;
    }
    const frame = requestAnimationFrame(() => setEntered(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  return entered;
}
